import {
  Clock,
  Loader2,
  CheckCircle2,
  XCircle,
  HelpCircle,
  AlertCircle,
} from 'lucide-react';

export type DisplayStatus =
  | 'queued'
  | 'pending'
  | 'started'
  | 'success'
  | 'failure'
  | 'unknown'
  | 'error_checking';

const statusConfig = {
  queued: {
    icon: Clock,
    color: 'bg-gray-100 text-gray-800 border-gray-200',
    label: 'Queued',
  },
  pending: {
    icon: Clock,
    color: 'bg-blue-100 text-blue-800 border-blue-200',
    label: 'Pending',
  },
  started: {
    icon: Loader2,
    color: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    label: 'Processing',
  },
  success: {
    icon: CheckCircle2,
    color: 'bg-green-100 text-green-800 border-green-200',
    label: 'Complete',
  },
  failure: {
    icon: XCircle,
    color: 'bg-red-100 text-red-800 border-red-200',
    label: 'Failed',
  },
  unknown: {
    icon: HelpCircle,
    color: 'bg-gray-100 text-gray-600 border-gray-200',
    label: 'Unknown',
  },
  error_checking: {
    icon: AlertCircle,
    color: 'bg-orange-100 text-orange-800 border-orange-200',
    label: 'Error checking',
  },
};

export const IngestionStatusBadge = ({ status }: { status: DisplayStatus }) => {
  const config = statusConfig[status];
  const Icon = config.icon;

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border ${config.color}`}
    >
      <Icon className='h-3.5 w-3.5' />
      {config.label}
    </span>
  );
};
